import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {ConfirmDialogService} from "../services/confirm-dialog.service";
import {SharedToolsService} from '../services/shared-tools.service';
import {ROUTES_PATHS} from "../const/routes";

@Injectable({
	providedIn: 'root'
})
export class AccessGuardGuard implements CanActivate {

	constructor(
		private router: Router,
		private confirmDialogService: ConfirmDialogService,
		private sharedToolsService: SharedToolsService,
	) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const token = JSON.parse(localStorage.getItem("token")!);
		const outOfSimu: boolean = (token && token?.outOfSimu) ? token.outOfSimu : false;
		console.log("canActivate outOfSimu ==> ", outOfSimu);
		if (outOfSimu) {
			// Si OutOfSimu est à true, on redirige vers la page de mon compte
			this.sharedToolsService.getJSON('txtModals').subscribe((txtModalsJson: any) => {
				this.confirmDialogService.confirmThis('', txtModalsJson.data.modalOutOfSimuTrue, 'alert', '', () => {
					this.router.navigate([ROUTES_PATHS.MON_COMPTE]);
				}, () => {
				});
			});
			return false;
		} else {
			// Si  OutOfSimu est à false, on continue
			return true;

		}
	}

}
